import React, {Component} from 'react';
import './css/header.css';
class DefaultHeader extends Component {
  constructor(props) {
    super(props);
    this.state={feesieId: "FEESIE"};
    this.setFeesieId = this.setFeesieId.bind(this);
  }
  setFeesieId() {
    if (sessionStorage.getItem("feesieId") && !this.state.displayingId) {
      this.setState({feesieId: sessionStorage.getItem("feesieId"), displayingId: true});
    } else if(this.state.displayingId) {
      this.setState({feesieId: "FEESIE", displayingId: false});
    }
  }
  render() {
    return <header className="App-header">     
     <h1 onClick={this.setFeesieId} className="App-title noselect">{this.state.feesieId}</h1>
   </header>
  }
}
export default DefaultHeader;



// WEBPACK FOOTER //
// ./src/defaultHeader.js